import { Spinner } from '@kintsugi/ui';
import { Flex } from '@chakra-ui/react';
import debounce from 'lodash/debounce';
import { Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import AppLayoutMd from './app-layout.md';
import AppLayoutSm from './app-layout.sm';

const LoadingFallback = () => (
  <Flex justifyContent="center" alignItems="center" w="full" h="100vh">
    <Spinner />
  </Flex>
);

export const AppLayout = (): React.ReactNode => {
  const mediaQueryList = window.matchMedia('(min-width: 768px)');
  const [matches, setMatches] = useState<boolean>(mediaQueryList.matches);

  useEffect(() => {
    const handler = debounce((e: MediaQueryListEvent) => setMatches(e.matches), 200);
    mediaQueryList.addEventListener('change', handler);

    return () => {
      handler.cancel(); // Cancel any pending debounced calls
      mediaQueryList.removeEventListener('change', handler);
    };
  }, [mediaQueryList]);

  return !matches ? (
    <AppLayoutSm>
      <Suspense fallback={<LoadingFallback />}>
        <Outlet />
      </Suspense>
    </AppLayoutSm>
  ) : (
    <AppLayoutMd>
      <Suspense fallback={<LoadingFallback />}>
        <Outlet />
      </Suspense>
    </AppLayoutMd>
  );
};
